import React, { Fragment, useState, useEffect, useMemo, useCallback } from "react";
import { useToggle, useLocalStorage } from "react-use";
import { TextSmall } from "../../components/typography";
import Flex from "../../components/templates/flex";
import Layer from "../../components/templates/layer";
import Container from "./container";
import Header from "./header";
import Item from "./item";
import { fetchNews } from "./datasource";
var emptyArray = [];
var News = function (_a) {
    var _b = _a.app, app = _b === void 0 ? "cloud" : _b, onCloseClick = _a.onCloseClick, children = _a.children;
    var _c = useLocalStorage("news_last_seen"), lastSeen = _c[0], setLastSeen = _c[1];
    var _d = useState(emptyArray), news = _d[0], setNews = _d[1];
    var _e = useState(), error = _e[0], setError = _e[1];
    var _f = useToggle(), isOpen = _f[0], toggle = _f[1];
    useEffect(function () {
        fetchNews(app, function (_a) {
            var results = _a.results;
            return setNews(results);
        }, function () { return setError(true); });
    }, []);
    var upToDate = useMemo(function () {
        if (!news.length)
            return true;
        var firstItem = news[0];
        var publishedAt = firstItem.last_publication_date;
        return new Date(lastSeen) >= new Date(publishedAt);
    }, [lastSeen, news]);
    var onClose = useCallback(function () {
        toggle();
        setLastSeen(new Date());
        if (onCloseClick)
            onCloseClick();
    }, [onCloseClick]);
    return (React.createElement(Fragment, null,
        children({ toggle: toggle, isOpen: isOpen, upToDate: upToDate }),
        isOpen && (React.createElement(Layer, { backdrop: true, onClickOutside: onClose, onEsc: onClose },
            React.createElement(Flex, { background: "dropdown", round: true, padding: [6], width: "640px", height: { max: "640px" }, gap: 4, column: true },
                React.createElement(Header, { onClose: onClose }),
                React.createElement(Container, { column: true, gap: 6 },
                    error && React.createElement(TextSmall, { textAlign: "center" }, "Something went wrong \uD83D\uDE14"),
                    !error && !news.length && React.createElement(TextSmall, { textAlign: "center" }, "There are no latest news"),
                    !error && news.length > 0 && news.map(function (item) { return React.createElement(Item, { key: item.id, item: item }); })))))));
};
export default News;
